import { addVoucher } from "../../../app/api/manageVoucher";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IAddVoucherActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { IVoucherDetail } from "../../../Orchestrator/Types/Interface/IVoucherDetail";
import { fetchVouchersAction } from "./FetchVouchersAction";

export class AddVoucherAction extends BaseAction<IVoucherDetail, IAddVoucherActionParams> {
    override async run(): Promise<IVoucherDetail> {
        const { userId, voucherCode } = this.params!
        let voucherData: IVoucherDetail = {} as IVoucherDetail;
        try {
            const response: any = await addVoucher(userId, voucherCode);
            if (response.status === "ok" && response.answer) {
                voucherData = response.answer;
                fetchVouchersAction.setParams({ userId });
                await fetchVouchersAction.execute();
            }
        }
        catch (error) {
            console.error("Error during adding voucher:", error);
        }
        finally {
            return voucherData;
        }
    }
}
export const addVoucherAction = new AddVoucherAction();
